import type { CSSProperties } from "react"

import { cn } from "@/domains/library"

import { HERO_TOP_PULSE_ANCHORS, HERO_TOP_PULSE_RING_COUNT } from "./hero-top-pulse-data"

export function HeroTopPulseView({ className }: { readonly className?: string }) {
  return (
    <div
      className={cn("hero-top-pulse-layer pointer-events-none absolute inset-x-0 top-0 z-0", className)}
      aria-hidden
    >
      {HERO_TOP_PULSE_ANCHORS.map((anchor, anchorIndex) => (
        <div
          key={`hero-pulse-${anchorIndex}`}
          className="hero-top-pulse-anchor absolute"
          style={{
            left: `${anchor.xPercent}%`,
            top: `${anchor.yPercent}%`,
          }}
        >
          {Array.from({ length: HERO_TOP_PULSE_RING_COUNT }, (_, ringIndex) => (
            <span
              key={`ring-${ringIndex}`}
              className="hero-top-pulse-ring"
              style={
                {
                  "--hero-ring-duration": `${anchor.ringDuration}s`,
                  "--hero-ring-delay": `${anchor.ringDelay + ringIndex * 1.8}s`,
                } as CSSProperties
              }
            />
          ))}

          <svg
            className="hero-top-pulse-plus"
            width={anchor.plusSize}
            height={anchor.plusSize}
            viewBox="0 0 12 12"
            style={
              {
                "--hero-plus-duration": `${anchor.plusDuration}s`,
                "--hero-plus-delay": `${anchor.plusDelay}s`,
              } as CSSProperties
            }
          >
            <line x1="6" y1="2" x2="6" y2="10" stroke="currentColor" strokeWidth="1" />
            <line x1="2" y1="6" x2="10" y2="6" stroke="currentColor" strokeWidth="1" />
          </svg>
        </div>
      ))}
    </div>
  )
}
